.container {
  height: 100%;
  width: 100%;
}

.logo {
  display: block;
}

.heading {
  font-size: 1.5rem; /* text-2xl */
  font-weight: bold;
  margin-top: 2.5rem; /* mt-10 */
}

.faqBox {
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 1rem; /* gap-4 */
  padding: 0.75rem; /* p-3 */
  border: 1px solid #c1b9b9;
  border-radius: 0.5rem;
  margin-top: 1.25rem; /* mt-5 */
  height: 50%;
  overflow-y: auto;
}

.inputWrapper {
  padding: 0.5rem;
  background-color: #f2efef !important;
  border-radius: 0.5rem !important;
}

.inputInner {
  border: none !important;
  background: transparent !important;
}

.supportItem {
  display: flex;
  background-color: white;
  border: none;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  padding-inline: 0.75rem;
  font-weight: 500;
  cursor: pointer;
}

.feedbackLink {
  display: flex;
  text-align: left;
  flex-direction: column;
  padding: 0.75rem 1.25rem;
  font-weight: bold;
  font-size: 1.125rem;
  border: 1px solid #c1b9b9;
  margin-top: 1rem;
  border-radius: 0.5rem;
  background-color: white;
  cursor: pointer;
}
